"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ui_1 = require("@bodiless/ui");

var fclasses_1 = require("@bodiless/fclasses");

var TextSelectorWrapper = fclasses_1.addClasses('bl-grid bl-bg-white bl-rounded bl-p-2')(ui_1.Div);
exports.default = TextSelectorWrapper;